import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ImagePlaceholder } from '../ImagePlaceholder/ImagePlaceholder'
import { cx } from '../utils/cx'
import './PhotoStep.css'

export interface PhotoStepProps {
  number: number
  title: ReactNode
  text: ReactNode
  /** URL de la foto real o nodo; sin ella, marcador con `imageLabel` */
  image?: string | ReactNode
  /** Texto alternativo de la foto (obligatorio si hay foto real) */
  imageAlt?: string
  imageLabel?: string
  className?: string
}

/** Paso con foto (bundle B4/B8): tarjeta con imagen 16:10 arriba y número en círculo primary de 32 px + título h3 + texto. */
export function PhotoStep({ number, title, text, image, imageAlt = '', imageLabel, className }: PhotoStepProps) {
  const { t } = useTranslation()
  return (
    <li className={cx('hp-photostep', className)}>
      <div className="hp-photostep__media">
        {typeof image === 'string' ? <img src={image} alt={imageAlt} className="hp-photostep__img" /> : (image ?? <ImagePlaceholder label={imageLabel || imageAlt || t('v2.ds.photoStep.foto', { number })} />)}
      </div>
      <div className="hp-photostep__body">
        <span className="hp-photostep__number tnum" aria-hidden="true">
          {number}
        </span>
        <div>
          <div className="hp-photostep__title">
            <span className="visually-hidden">{number}. </span>
            {title}
          </div>
          <div className="hp-photostep__text">{text}</div>
        </div>
      </div>
    </li>
  )
}

/** Lista ordenada de pasos con foto. */
export function PhotoSteps({ children, className }: { children: ReactNode; className?: string }) {
  return <ol className={cx('hp-photosteps', className)}>{children}</ol>
}
